
import Vue from 'vue'

export default Vue.extend({
  name: 'RCheckbox',
  props: {
    checked: {
      type: Boolean,
      required: false,
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  // this is how we customize the component's
  // v-model behavior so that the parent's value
  // goes to the 'checked' prop
  model: {
    prop: 'checked',
    event: 'change',
  },
  methods: {
    handleChange(event: InputEvent) {
      this.$emit('change', (event.target as HTMLInputElement).checked)
    },
  },
})
